import { useQuery } from 'react-query'
import chatApi from '../api/chatApi'

export default function useHasDifferentiatedDiagnosis(): boolean {
  const { data } = useQuery('unfinishedTaskHasDifferentiatedDiagnosis', () => chatApi.unfinishedTask(), {
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false
  })

  return Boolean(data?.result?.task?.hasDifferentiatedDiagnosis)
}
